
import React from "react"



import Header from "./header"
import Footer from "./Footer"
import "./layout.css"
import "../styles/custom.css"
import { useState } from "react"

import ScrollToTop from 'react-scroll-up';
import Usabanner from "./Usabanner";






const Layout = ({ children }) => {
   const Imagee4 = "/btn-back-to-top.png"


   // console.log('Global: ',global)
   return (
      <div className="flex flex-col justify-between min-h-screen">
         {/* Aligned to the top */}

         <div className="flex-1">
            <Usabanner />

            <Header />


            <div
            >{children}</div>





            {/* Aligned to the bottom */}
            <ScrollToTop showUnder={160} style={{ zIndex: 99 }}><button id="myBtn1" title="Go to top"  ><span style={{ fontStretch: "exnded" }}> <img className="inline pr-2" src={Imagee4} alt="Go to Top" /></span></button>
            </ScrollToTop>


            <footer className="pt-4 cta--blue  text-gray-50 text-sm border-yellow-500 border-t-4">
               <div className="relative flex flex-col md:flex-row md:justify-between pt-8">
                  <nav className="flex flex-row flex-wrap  items-start mb-2 text-gray-50 text-sm md:w-4/5 mx-auto md:px-12 pb-4">
                     <div className="mt-2 lg:mt-0 w-full md:w-1/3 ">
                        <p className="uppercase tracking-wide font-semibold white border-yellow-500 border-b-2 w-1/2 md:w-3/4">SITE SUPPORT</p>
                        <div>
                           <ul className="mt-2 w-1/2 md:w-3/4 p-0">
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg">
                                    <a href="https://www.acl.gov/node/445" className=" focus:outline-none" target="_self">Privacy Policy</a></div>
                              </li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg">
                                    <a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" className=" focus:outline-none" target="_self">Vulnerability Disclosure Policy</a>
                                 </div>
                              </li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg"><a href="https://www.acl.gov/node/444" className=" focus:outline-none" target="_self">Accessibility</a></div></li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg"><a href="https://www.hhs.gov/plugins.html" className=" focus:outline-none" target="_self">Viewers &amp; Players</a>
                                 </div></li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg"><a href="https://www.acl.gov/node/446" className=" focus:outline-none" target="_self">Disclaimers</a></div></li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg"><a href="mailto:sitefeedback@acl.hhs.gov?subject=NCLER Web site" className=" focus:outline-none" target="_self">Site Feedback</a>
                                 </div></li></ul></div></div>
                     <div className="mt-10 lg:mt-0 w-full md:w-1/3 ">
                        <p className="uppercase tracking-wide font-semibold white border-yellow-500 border-b-2 w-1/2 md:w-3/4">RESOURCES</p>
                        <div>
                           <ul className="mt-2 w-1/2 md:w-3/4 p-0">
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg">
                                    <a href="https://www.acl.gov/node/447" className=" focus:outline-none" target="_self">Freedom of Information Act</a></div></li>
                              <li className="text-gray-50  px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg">
                                    <a href="https://www.hhs.gov/open/plain-writing/index.html" className=" focus:outline-none" target="_self">Plain Writing Statement</a></div></li>
                              <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                                 <div className="w-full ml-auto text-lg">
                                    <a href="https://www.hhs.gov/about/agencies/asa/eeo/resources/no-fear-act/index.html" className=" focus:outline-none" target="_self">No Fear Act - Equal Employment Opportunity </a></div></li></ul></div></div>
                     <div className="mt-10 lg:mt-0 w-full md:w-1/3 ">
                        <p className="uppercase tracking-wide font-semibold white border-yellow-500 border-b-2 w-1/2 md:w-3/4">ACL PARTNERS</p>
                        <div><ul className="mt-2 w-1/2 md:w-3/4 p-0">
                           <li className="text-gray-50 px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                              <div className="w-full ml-auto text-lg">
                                 <a href="https://acl.gov/" className=" focus:outline-none" target="_self">ACL.gov</a></div></li>
                           <li className="text-gray-50 px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                              <div className="w-full ml-auto text-lg">
                                 <a href="https://hhs.gov/" className=" focus:outline-none" target="_self">HHS.gov</a></div></li>
                           <li className="text-gray-50  px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                              <div className="w-full ml-auto text-lg"><a href="https://usa.gov/" className=" focus:outline-none" target="_self">USA.gov</a></div></li>
                           <li className="text-gray-50   px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                              <div className="w-full ml-auto text-lg">
                                 <a href="https://grants.gov/" className=" focus:outline-none" target="_self">Grants.gov</a></div></li>
                           <li className="text-gray-50 px-1 pr-4 border-opacity-25 -mx-1 hover:text-yellow-500 border-gray-500 border-b-2 lipad">
                              <div className="w-full ml-auto text-lg"><a href="https://whitehouse.gov/" className=" focus:outline-none" target="_self">Whitehouse.gov</a>
                              </div></li></ul></div></div>
                  </nav></div>
               <div className="text-xs cta-blue-light text-gray-50 flex"><div className="pt-3  md:w-4/5 mx-auto text-center pb-1"><span><span style={{ textAlign: "center" }}><a href="https://hhs.gov/"><span style={{ fontSize: "17px" }}><strong>U.S. Department of Health and Human Services</strong></span></a><span style={{ fontSize: "17px" }}><strong>, </strong></span><a href="https://acl.gov/"><span style={{ fontSize: "17px" }}><strong>Administration for Community Living</strong></span></a><br /><span style={{ fontSize: "17px" }}><i>Advancing independence, integration, and inclusion throughout life</i></span></span></span></div></div></footer>
         </div>
      </div>
   )
}


export default Layout
